import HighlightClipInfoOverlay from './HighlightClipInfoOverlay';

export default HighlightClipInfoOverlay;
